import { PropsWithChildren } from 'react';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { Button } from '@shared/ui/components/Button';
import { PaginationItemProps } from '@shared/ui/components/Pagination/Pagination.types';
import { cn } from '@shared/utils/helpers';

export function PaginationItem({
  page,
  isCurrent,
  onClick,
  className,
  children,
}: PropsWithChildren<PropsWithClassName<PaginationItemProps>>) {
  return (
    <li className={cn('', className)}>
      <Button
        variant={isCurrent ? 'default' : 'ghost'}
        size="sm"
        disabled={!page}
        className={[{ 'cursor-pointer': page }, 'select-none', className]}
        onClick={onClick}
      >
        {children}
      </Button>
    </li>
  );
}
